import { apiRequest } from '../lib/httpClient'
import type { SurveyFormSubmission } from '../types/surveyForm'

function pickString(value: unknown): string {
  return typeof value === 'string' ? value : String(value ?? '')
}

function mapSubmission(raw: Record<string, unknown>): SurveyFormSubmission {
  let jsonData: Record<string, string | number> = {}
  try {
    const rawJson = raw['jsonData']
    const parsed = typeof rawJson === 'string' ? JSON.parse(rawJson) : rawJson
    jsonData = parsed ?? {}
  } catch {
    /* empty */
  }

  return {
    surveyFormId: pickString(raw['surveyFormId']),
    clientId: pickString(raw['clientId']),
    fullName: pickString(raw['fullName']),
    email: pickString(raw['email']),
    monthEndDate: pickString(raw['monthEndDate']),
    insertDate: pickString(raw['insertDate']),
    updateDate: raw['updateDate'] ? pickString(raw['updateDate']) : null,
    insertUserId: pickString(raw['insertUserId']),
    jsonData,
  }
}

export async function fetchSurveyForms(clientId: string): Promise<SurveyFormSubmission[]> {
  const raw = await apiRequest<Record<string, unknown>[]>('surveyForm/ui/forms', {
    query: { clientId },
  })
  return (raw ?? []).map(mapSubmission)
}

export async function saveSurveyForm(
  clientId: string,
  surveyFormData: Record<string, string | number>
): Promise<unknown> {
  return apiRequest('surveyForm/ui/save', {
    method: 'POST',
    body: { clientId, surveyFormData },
  })
}

export async function updateSurveyForm(
  surveyFormId: string,
  clientId: string,
  surveyFormData: Record<string, string | number>
): Promise<unknown> {
  return apiRequest(`surveyForm/ui/update/${surveyFormId}`, {
    method: 'POST',
    body: { clientId, surveyFormData },
  })
}

export async function deleteSurveyForm(surveyFormId: string, clientId: string): Promise<void> {
  await apiRequest<void>(`surveyForm/ui/delete/${surveyFormId}`, {
    method: 'DELETE',
    query: { clientId },
  })
}
